import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AddressDTO } from "../../schema/Billing/Customer/AddressDTO";

@Injectable({
    providedIn: "root"
})
export class ApiBillingZipCodesService {
    private relativePath: string;

    constructor(private http: HttpClient) {
        this.relativePath = `${environment.billing.url}/api/v1/Zipcodes`;
    }

    public getAddressByZipCode(zipCode: string): Observable<AddressDTO> {
        return this.http.get<AddressDTO>(`${this.relativePath}?zipCode=${zipCode}`);
    }
}
